/**
 * §8.13 Final CTA — "Need More Help?".
 */

import React from 'react'
import { LifeBuoy, Calendar, Sparkles } from 'lucide-react'
import {
  Container, Eyebrow, GradientButton, GhostButton,
} from '@/components/landing/design-system'

export default function FinalCTA() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10 opacity-[0.6]"
        style={{ background: 'radial-gradient(60% 45% at 50% 20%, rgba(255,193,7,0.16), transparent 70%)' }} />
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide">
        <div className="relative rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-white/[0.01] p-8 md:p-12 lg:p-14 backdrop-blur-xl overflow-hidden">
          <div className="pointer-events-none absolute -top-20 -left-20 h-64 w-64 rounded-full bg-brand-gold/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-emerald-500/10 blur-3xl" />
          <div className="relative flex flex-col items-center text-center gap-6 max-w-3xl mx-auto">
            <Eyebrow>Need More Help?</Eyebrow>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-[1.05]">
              We&apos;re here to help you{' '}
              <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">launch and grow.</span>
            </h2>
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed">
              Our documentation, resources and support team are here to help you successfully
              launch and grow your AI trading SaaS platform — no matter which phase you&apos;re in.
            </p>
            <div className="flex flex-col sm:flex-row items-stretch gap-3 pt-2">
              <GradientButton href="#support" size="lg">
                <LifeBuoy className="h-4 w-4" /> Contact support
              </GradientButton>
              <GhostButton href="/contact" size="lg" trailingIcon>
                <Calendar className="h-4 w-4" /> Schedule demo
              </GhostButton>
            </div>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-[11px] text-zinc-500">
              <span className="inline-flex items-center gap-1.5"><Sparkles className="h-3 w-3 text-brand-gold" /> 120+ docs · 40+ videos</span>
              <span>·</span><span>Predictive help centre</span>
              <span>·</span><span>Real humans, real SLAs</span>
              <span>·</span><span>Continuous release cadence</span>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
